import styled from 'styled-components';
import { color, layout, mobile, tablet } from '../../../GlobalStyles';

const { size1, size3, size4, size5, size6, cornerRadius2 } = layout;
const { royalBlue1, royalBlue2, gray2, gray7, gray9 } = color;

export const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size5}px;
  margin-top: ${size6}px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${size4}px;
  }
`;

export const ModelName = styled.span.attrs({ className: 'label-regular' })``;
export const ToggleLabel = styled.span.attrs({ className: 'label-regular' })``;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${size3}px;
`;

export const PlanCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: ${size4}px;

  ${tablet} {
    gap: ${size3}px;
  }

  ${mobile} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const Content = styled.div``;

export const Card = styled.div`
  border: 1px solid ${royalBlue1};
  border-radius: ${cornerRadius2}px;
`;

export const CardHeader = styled.div`
  background-color: ${royalBlue1};
  padding: ${size3}px;
  border-top-left-radius: ${cornerRadius2}px;
  border-top-right-radius: ${cornerRadius2}px;
`;

export const MainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size1}px;
  padding: ${size5}px ${size3}px ${size3}px;
`;

export const PlanName = styled.span.attrs({ className: 'label-regular' })``;

export const PlanPrice = styled.span.attrs({ className: 'subtitle-regular' })``;

export const PlanPages = styled.span.attrs({ className: 'label-regular' })`
  color: ${gray9};
  margin-bottom: ${size5}px;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${royalBlue2};
`;

export const DetailedInfo = styled.ul`
  display: flex;
  flex-direction: column;
  color: ${gray7};
  list-style-type: disc;
  list-style-position: inside;
  padding: 0 ${size3}px ${size3}px;
  gap: 6px;
`;

export const InfoText = styled.li.attrs({ className: 'caption-small' })`
  padding-left: 6px;
  text-indent: -${size4}px;
  margin-left: 18px;

  &:before {
    content: '';
    margin-left: -4px;
  }
`;

export const PaperInfoText = styled.li.attrs({ className: 'caption-small' })`
  background-color: ${gray2};
  border-radius: 6px;
  padding: ${size1}px 6px;
  text-indent: -${size4}px;
  padding-left: ${size6}px;

  &:before {
    content: '';
    margin-left: -${size1}px;
  }
`;
